import React from 'react';
import PropTypes from 'prop-types';

import {
	Wrapper,
	Heading,
	Text,
	Button,
} from './emptyStateStyles';

const EmptyState = ({ heading, subText, ctaText, onClick }) => {
	return (
		<Wrapper>
			<Heading>{heading}</Heading>
			<Text>{subText}</Text>
			<Button size={"sm"} onClick={onClick}>
				{ctaText}
			</Button>
		</Wrapper>
	);
};

EmptyState.propTypes = {
	heading: PropTypes.string,
	subText: PropTypes.string,
	ctaText: PropTypes.string,
	onClick: PropTypes.func,
};

EmptyState.defaultProps = {
	heading: 'Have a question?',
	subText: 'Ask the community and get help from thousands of informed subscribers.',
	ctaText: 'Ask the Community',
	onClick: () => null,
};

export default EmptyState;
